// TODO: localize
export const text = {
    bold: `Bold`,
    italic: `Italic`,
    underline: `Underline`,
    strikethrough: `Strikethrough`,
    heading1: `Heading 1`,
    heading2: `Heading 2`,
    heading3: `Heading 3`,
    heading4: `Heading 4`,
    heading5: `Heading 5`,
    heading6: `Heading 6`,
    code: `Code`,
    addLink: `Add Link`,
    blockquote: `Quote`,
    bulletedList: `Bulleted List`,
    numberedList: `Numbered List`,
    insertChecklist: `Insert Checklist`,
    normalText: `Normal Text`,
    smallText: `Small Text`,
    codeSnippet: `Code Snippet`,
    textAlign: `Text Align`,
    alignLeft: `Align Left`,
    alignCenter: `Align Center`,
    alignRight: `Align Right`,
    textColor: `Text Color`,
    highlightColor: `Highlight Color`,
    lastUsed: `Last Used`,
    colors: `Colors`,
    textStyle: `Text Style`,
    askAi: `Ask AI`,
    extraLarge: `Extra Large Text`,
    largeText: `Large Text`,
    mediumText: `Medium Text`,
    caption: `CAPTION`,
};
